module.exports = __webpack_public_path__ + "static/media/predict_tag.f5dff9d2.svg";